export default function Confidentialite() {
  return (
    <div className="page">
      <div className="card">
        <h1>Politique de confidentialité</h1>

        <p>
          Ce site utilise Google AdSense, un service de diffusion de publicité
          fourni par Google Inc.
        </p>

        <p>
          Google utilise des cookies pour diffuser des annonces en fonction des
          visites antérieures de l’utilisateur sur ce site ou d’autres sites.
        </p>

        <p>
          Grâce au cookie DoubleClick, Google et ses partenaires adaptent les
          annonces diffusées aux utilisateurs.
        </p>

        <p>
          Vous pouvez désactiver la publicité personnalisée en consultant :
          <br />
          <a
            href="https://adssettings.google.com"
            target="_blank"
            rel="noreferrer"
          >
            https://adssettings.google.com
          </a>
        </p>

        <p>
          Aucune donnée personnelle n’est collectée directement par ce site.
        </p>
      </div>
    </div>
  );
}
